(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-tabs')) {
    class CollectionTabs extends HTMLElement {
      connectedCallback() {
        this.pills = Array.from(this.querySelectorAll('.ct__pill'));
        this.panels = Array.from(this.querySelectorAll('.ct__panel'));

        this.pills.forEach((pill) => {
          pill.addEventListener('click', () => this.select(pill.dataset.panel));
        });
      }

      select(id) {
        this.pills.forEach((pill) => {
          const on = pill.dataset.panel === id;
          pill.classList.toggle('is-active', on);
          pill.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        if (id === 'all') {
          this.panels.forEach((panel) => panel.classList.add('is-active'));
        } else {
          this.panels.forEach((panel) => {
            panel.classList.toggle('is-active', panel.dataset.panel === id);
          });
        }
      }
    }

    customElements.define('collection-tabs', CollectionTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["color-block-collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('color-block-carousel')) {
    class ColorBlockCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cbcl-grid');
        this.prevBtn = this.querySelector('.cbcl-carousel__btn--prev');
        this.nextBtn = this.querySelector('.cbcl-carousel__btn--next');
        if (!this.track || !this.prevBtn || !this.nextBtn) return;

        this.prevBtn.addEventListener('click', () => this.scrollByColumns(-1));
        this.nextBtn.addEventListener('click', () => this.scrollByColumns(1));

        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        this.resizeObserver = new ResizeObserver(() => {
          this.update();
          this.equalizeColorBlocks();
        });
        this.resizeObserver.observe(this.track);
        this.update();
        this.equalizeColorBlocks();
        // Re-measure once webfonts land — they change text wrapping.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => this.equalizeColorBlocks());
        }
      }

      // Give every colour block the height of the tallest one.
      equalizeColorBlocks() {
        const blocks = this.track.querySelectorAll('.cbcl-card__color');
        if (!blocks.length) return;
        this.track.style.removeProperty('--cbcl-color-block-height');
        let max = 0;
        blocks.forEach((block) => {
          max = Math.max(max, block.offsetHeight);
        });
        this.track.style.setProperty('--cbcl-color-block-height', `${max}px`);
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      // Distance from one column to the next (card width + gap).
      pitch() {
        const items = this.track.querySelectorAll('.cbcl-grid__item');
        if (items.length > 1) return items[1].offsetLeft - items[0].offsetLeft;
        return items[0] ? items[0].offsetWidth : this.track.clientWidth;
      }

      scrollByColumns(direction) {
        // Round the current position to a whole column first, so every click
        // lands exactly on a column boundary even from a mid-drag position.
        const pitch = this.pitch();
        if (!pitch) return;
        const target = Math.round(this.track.scrollLeft / pitch) + direction;
        this.track.scrollTo({ left: target * pitch });
      }

      update() {
        const overflow = this.track.scrollWidth > this.track.clientWidth + 1;
        this.prevBtn.hidden = !overflow;
        this.nextBtn.hidden = !overflow;
        if (!overflow) return;
        this.prevBtn.disabled = this.track.scrollLeft <= 1;
        this.nextBtn.disabled = this.track.scrollLeft >= this.track.scrollWidth - this.track.clientWidth - 1;
      }
    }

    customElements.define('color-block-carousel', ColorBlockCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-contact-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.cf-grid').forEach((grid) => {
      // Checkbox groups: mirror the ticked options into the proxy input that
      // actually posts (and satisfies `required`).
      grid.querySelectorAll('[data-cf-checkbox-group]').forEach((group) => {
        const proxy = group.querySelector('.cf-group-proxy');
        if (!proxy) return;
        group.addEventListener('change', () => {
          const picked = Array.from(group.querySelectorAll('input[type="checkbox"]:checked')).map(
            (box) => box.value
          );
          proxy.value = picked.join(', ');
        });
      });

      // "Disallow past dates": Liquid renders min at publish time, which can
      // go stale on cached pages — reset it to the visitor's actual today.
      grid.querySelectorAll('[data-cf-min-today]').forEach((input) => {
        const now = new Date();
        now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
        input.min = now.toISOString().slice(0, 10);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gradient-marquee-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-bar')) {
    class MarqueeBar extends HTMLElement {
      connectedCallback() {
        this.marquee = this.querySelector('.marquee');
        this.track = this.querySelector('.marquee__track');
        this.baseGroup = this.track ? this.track.querySelector('.marquee__group') : null;
        if (!this.marquee || !this.track || !this.baseGroup) return;

        this.speed = parseFloat(this.dataset.speed) || 50;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.build = this.build.bind(this);
        this.build();

        this.resizeObserver = new ResizeObserver(this.debounce(this.build, 150));
        this.resizeObserver.observe(this);

        if (this.reduceMotion.addEventListener) {
          this.reduceMotion.addEventListener('change', this.build);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      build() {
        // Reset to a single, original group before (re)measuring.
        const groups = this.track.querySelectorAll('.marquee__group');
        groups.forEach((group, index) => {
          if (index > 0) group.remove();
        });
        this.marquee.classList.remove('marquee--animate');

        if (this.reduceMotion.matches) return;

        const containerWidth = this.marquee.offsetWidth;
        const groupWidth = this.baseGroup.scrollWidth;
        if (!containerWidth || !groupWidth) return;

        // How many copies of the group are needed to cover the viewport once...
        const copiesPerUnit = Math.max(1, Math.ceil(containerWidth / groupWidth));
        // ...then duplicate that whole unit so a -50% shift loops seamlessly.
        const totalGroups = copiesPerUnit * 2;

        const fragment = document.createDocumentFragment();
        for (let i = 1; i < totalGroups; i++) {
          const clone = this.baseGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);

        // Distance travelled per loop = one unit width; keep speed constant (px/s).
        const trackGap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const unitWidth = groupWidth * copiesPerUnit + trackGap * copiesPerUnit;
        const duration = unitWidth / this.speed;
        this.track.style.setProperty('--marquee-duration', `${duration}s`);
        this.marquee.classList.add('marquee--animate');
      }
    }

    customElements.define('marquee-bar', MarqueeBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-with-search"]) return;
  try {
    
  if (!customElements.get('sticky-header')) {
    class StickyHeader extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.header = document.querySelector('.section-header');
        this.headerIsAlwaysSticky =
          this.getAttribute('data-sticky-type') === 'always' ||
          this.getAttribute('data-sticky-type') === 'reduce-logo-size';
        this.headerBounds = {};

        this.setHeaderHeight();

        window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

        if (this.headerIsAlwaysSticky) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        this.currentScrollTop = 0;
        this.preventReveal = false;
        this.predictiveSearch = this.querySelector('predictive-search');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
      }

      setHeaderHeight() {
        document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
      }

      disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
      }

      createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
          this.headerBounds = entries[0].intersectionRect;
          observer.disconnect();
        });

        observer.observe(this.header);
      }

      onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }

      hide() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        this.closeMenuDisclosure();
        this.closeSearchModal();
      }

      reveal() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }

      reset() {
        if (this.headerIsAlwaysSticky) return;
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }

      closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach((disclosure) => disclosure.close());
      }

      closeSearchModal() {
        this.searchModal = this.searchModal || this.header.querySelector('details-modal');
        if (this.searchModal) this.searchModal.close(false);
      }
    }

    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["looping-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('looping-slideshow')) {
    class LoopingSlideshow extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.lps__viewport');
        this.track = this.querySelector('.lps__track');
        this.slides = Array.from(this.track.children);
        this.count = this.slides.length;
        if (this.count < 2) return;

        // Clone the last slide to the front and the first to the end so the
        // loop never shows an empty edge. Clones are decorative only.
        const firstClone = this.slides[0].cloneNode(true);
        const lastClone = this.slides[this.count - 1].cloneNode(true);
        [firstClone, lastClone].forEach((clone) => {
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a, button').forEach((el) => el.setAttribute('tabindex', '-1'));
        });
        this.track.prepend(lastClone);
        this.track.append(firstClone);

        this.index = 0;
        this.dragged = false;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.position(false);
        // Enable transitions only after first paint so load doesn't animate.
        requestAnimationFrame(() => this.classList.add('lps--animate'));

        new ResizeObserver(() => this.position(false)).observe(this);

        this.track.addEventListener('transitionend', (event) => {
          if (event.target !== this.track) return;
          // Landed on a clone: snap (no transition) to the matching real slide.
          if (this.index < 0) { this.index = this.count - 1; this.position(false); }
          if (this.index >= this.count) { this.index = 0; this.position(false); }
        });

        this.querySelectorAll('.lps__arrow--prev').forEach((b) => b.addEventListener('click', () => this.go(this.index - 1)));
        this.querySelectorAll('.lps__arrow--next').forEach((b) => b.addEventListener('click', () => this.go(this.index + 1)));

        this.bindDrag();
        this.bindAutoplay();

        // Theme editor: jump to a selected slide.
        document.addEventListener('shopify:block:select', (event) => {
          const slide = event.target && this.contains(event.target) ? event.target.closest('[data-lps-index]') : null;
          if (slide) this.go(parseInt(slide.dataset.lpsIndex, 10));
        });

        this.addEventListener('keyup', (event) => {
          if (event.key === 'ArrowLeft') this.go(this.index - 1);
          if (event.key === 'ArrowRight') this.go(this.index + 1);
        });
      }

      step() {
        const slide = this.track.children[1];
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return slide.getBoundingClientRect().width + gap;
      }

      // translateX that centers track child (this.index + 1) in the viewport.
      offset() {
        const w = this.viewport.getBoundingClientRect().width;
        const s = this.track.children[1].getBoundingClientRect().width;
        return (w - s) / 2 - (this.index + 1) * this.step();
      }

      position(animate) {
        if (!animate) this.classList.remove('lps--animate');
        this.track.style.transform = `translateX(${this.offset()}px)`;
        if (!animate) {
          this.track.getBoundingClientRect(); // flush so the jump isn't animated
          requestAnimationFrame(() => this.classList.add('lps--animate'));
        }
      }

      go(i) {
        this.index = Math.max(-1, Math.min(this.count, i));
        this.position(true);
        this.restartAutoplay();
      }

      bindDrag() {
        let startX = 0;
        let baseOffset = 0;
        let pointerId = null;

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.button > 0) return;
          pointerId = event.pointerId;
          startX = event.clientX;
          baseOffset = this.offset();
          this.dragged = false;
          this.classList.add('is-dragging');
          this.viewport.setPointerCapture(pointerId);
          this.stopAutoplay();
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (pointerId === null) return;
          const dx = event.clientX - startX;
          if (Math.abs(dx) > 5) this.dragged = true;
          this.track.style.transform = `translateX(${baseOffset + dx}px)`;
        });

        const release = (event) => {
          if (pointerId === null) return;
          pointerId = null;
          this.classList.remove('is-dragging');
          const dx = event.clientX - startX;
          const threshold = this.step() * 0.18;
          if (dx <= -threshold) this.go(this.index + 1);
          else if (dx >= threshold) this.go(this.index - 1);
          else this.position(true);
          this.restartAutoplay();
        };

        this.viewport.addEventListener('pointerup', release);
        this.viewport.addEventListener('pointercancel', release);

        // A real drag shouldn't trigger the slide's links.
        this.viewport.addEventListener('click', (event) => {
          if (this.dragged) {
            event.preventDefault();
            event.stopPropagation();
            this.dragged = false;
          }
        }, true);
      }

      bindAutoplay() {
        this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reduceMotion;
        this.autoplaySpeed = (parseInt(this.dataset.speed, 10) || 5) * 1000;
        if (!this.autoplayEnabled) return;
        this.addEventListener('mouseenter', () => this.stopAutoplay());
        this.addEventListener('mouseleave', () => this.restartAutoplay());
        this.restartAutoplay();
      }

      stopAutoplay() {
        clearInterval(this.autoplayTimer);
      }

      restartAutoplay() {
        if (!this.autoplayEnabled) return;
        this.stopAutoplay();
        this.autoplayTimer = setInterval(() => this.go(this.index + 1), this.autoplaySpeed);
      }

      disconnectedCallback() {
        this.stopAutoplay();
      }
    }

    customElements.define('looping-slideshow', LoopingSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('marquee-bar')) {
    class MarqueeBar extends HTMLElement {
      connectedCallback() {
        this.marquee = this.querySelector('.marquee');
        this.track = this.querySelector('.marquee__track');
        this.baseGroup = this.track ? this.track.querySelector('.marquee__group') : null;
        if (!this.marquee || !this.track || !this.baseGroup) return;

        this.speed = parseFloat(this.dataset.speed) || 50;
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.build = this.build.bind(this);
        this.build();

        this.resizeObserver = new ResizeObserver(this.debounce(this.build, 150));
        this.resizeObserver.observe(this);

        if (this.reduceMotion.addEventListener) {
          this.reduceMotion.addEventListener('change', this.build);
        }
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      debounce(fn, wait) {
        let t;
        return (...args) => {
          clearTimeout(t);
          t = setTimeout(() => fn.apply(this, args), wait);
        };
      }

      build() {
        // Reset to a single, original group before (re)measuring.
        const groups = this.track.querySelectorAll('.marquee__group');
        groups.forEach((group, index) => {
          if (index > 0) group.remove();
        });
        this.marquee.classList.remove('marquee--animate');

        if (this.reduceMotion.matches) return;

        const containerWidth = this.marquee.offsetWidth;
        const groupWidth = this.baseGroup.scrollWidth;
        if (!containerWidth || !groupWidth) return;

        // How many copies of the group are needed to cover the viewport once...
        const copiesPerUnit = Math.max(1, Math.ceil(containerWidth / groupWidth));
        // ...then duplicate that whole unit so a -50% shift loops seamlessly.
        const totalGroups = copiesPerUnit * 2;

        const fragment = document.createDocumentFragment();
        for (let i = 1; i < totalGroups; i++) {
          const clone = this.baseGroup.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
          fragment.appendChild(clone);
        }
        this.track.appendChild(fragment);

        // Distance travelled per loop = one unit width; keep speed constant (px/s).
        const trackGap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const unitWidth = groupWidth * copiesPerUnit + trackGap * copiesPerUnit;
        const duration = unitWidth / this.speed;
        this.track.style.setProperty('--marquee-duration', `${duration}s`);
        this.marquee.classList.add('marquee--animate');
      }
    }

    customElements.define('marquee-bar', MarqueeBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-tabs')) {
    class ProductTabs extends HTMLElement {
      connectedCallback() {
        this.pills = Array.from(this.querySelectorAll('.pt__pill'));
        this.panels = Array.from(this.querySelectorAll('.pt__panel'));

        this.pills.forEach((pill) => {
          pill.addEventListener('click', () => this.select(pill.dataset.panel));
        });
      }

      select(id) {
        this.pills.forEach((pill) => {
          const on = pill.dataset.panel === id;
          pill.classList.toggle('is-active', on);
          pill.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        this.panels.forEach((panel) => {
          panel.classList.toggle('is-active', panel.dataset.panel === id);
        });
        const panel = this.panels.find((p) => p.dataset.panel === id);
        if (panel && !panel.dataset.loaded) this.load(panel);
      }

      // Tabs other than the first render empty; fetch this section at the
      // tab's collection URL, where only that tab's cards are rendered.
      async load(panel) {
        const url = panel.dataset.collectionUrl;
        const grid = panel.querySelector('[data-pt-grid]');
        if (!url || !grid) return;
        panel.dataset.loaded = 'loading';
        panel.classList.add('is-loading');
        try {
          const joiner = url.includes('?') ? '&' : '?';
          const response = await fetch(`${url}${joiner}section_id=${this.dataset.sectionId}`);
          if (!response.ok) throw new Error(response.status);
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const fresh = doc.querySelector(`[data-panel="${panel.dataset.panel}"] [data-pt-grid]`);
          if (!fresh) throw new Error('panel missing');
          grid.innerHTML = fresh.innerHTML;
          panel.dataset.loaded = 'true';
        } catch {
          // Leave it retryable: the next click tries again.
          delete panel.dataset.loaded;
        } finally {
          panel.classList.remove('is-loading');
        }
      }
    }

    customElements.define('product-tabs', ProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-carousel')) {
    class ReviewCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.rc__viewport');
        this.track = this.querySelector('.rc__track');
        if (!this.viewport || !this.track) return;

        this.prev = this.querySelector('.rc__arrow--prev');
        this.next = this.querySelector('.rc__arrow--next');
        this.controls = this.querySelector('.rc__controls');
        this.index = 0;

        // Bound once; build() may swap the cards underneath them later.
        if (this.prev) this.prev.addEventListener('click', () => this.go(this.index - 1));
        if (this.next) this.next.addEventListener('click', () => this.go(this.index + 1));

        // After a step lands on a cloned set, jump (no animation) back to the
        // matching real card so it can keep going forever.
        this.track.addEventListener('transitionend', (event) => {
          if (event.target === this.track && event.propertyName === 'transform') this.normalize();
        });

        this.bindDrag();
        new ResizeObserver(() => this.position(false)).observe(this.viewport);

        // Curated blocks render server-side, so the carousel works immediately;
        // Judge.me reviews replace them once they arrive.
        this.build();
        if (this.dataset.jmToken && this.dataset.jmDomain) this.watchForRemote();
      }

      // (Re)reads the cards currently in the track and sets up the loop.
      build() {
        this.track.querySelectorAll('[data-rc-clone]').forEach((clone) => clone.remove());
        this.originals = Array.from(this.track.children);
        this.count = this.originals.length;
        this.index = 0;

        if (this.controls) this.controls.hidden = this.count < 2;
        // With one card there's nothing to loop.
        if (this.count < 2) {
          this.track.style.transform = '';
          return;
        }

        this.addClones();
        this.position(false);
        requestAnimationFrame(() => this.track.classList.add('rc__track--animate'));
      }

      addClones() {
        const before = document.createDocumentFragment();
        const after = document.createDocumentFragment();
        this.originals.forEach((card) => {
          [
            [before, card.cloneNode(true)],
            [after, card.cloneNode(true)],
          ].forEach(([frag, clone]) => {
            clone.setAttribute('aria-hidden', 'true');
            clone.setAttribute('data-rc-clone', '');
            clone.querySelectorAll('a').forEach((el) => el.setAttribute('tabindex', '-1'));
            frag.appendChild(clone);
          });
        });
        this.track.insertBefore(before, this.originals[0]);
        this.track.appendChild(after);
      }

      /* --- Judge.me --- */

      // Only fetch when the section is near the viewport; the reviews payload
      // is large and most visitors never scroll this far.
      watchForRemote() {
        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            observer.disconnect();
            this.loadRemote();
          },
          { rootMargin: '400px' }
        );
        observer.observe(this);
      }

      cacheKey() {
        return `judgeme-reviews:${this.dataset.jmDomain}`;
      }

      readCache() {
        try {
          const cached = JSON.parse(window.localStorage.getItem(this.cacheKey()) || 'null');
          // One day is plenty fresh for store reviews.
          if (!cached || Date.now() - cached.ts > 24 * 60 * 60 * 1000) return null;
          return cached;
        } catch {
          return null;
        }
      }

      writeCache(payload) {
        try {
          window.localStorage.setItem(this.cacheKey(), JSON.stringify({ ...payload, ts: Date.now() }));
        } catch {
          // Storage unavailable or full — just refetch next time.
        }
      }

      endpoint(path, params = '') {
        const { jmToken, jmDomain } = this.dataset;
        return `https://api.judge.me/api/v1/widgets/${path}?api_token=${encodeURIComponent(
          jmToken
        )}&shop_domain=${encodeURIComponent(jmDomain)}${params}`;
      }

      async loadRemote() {
        const cached = this.readCache();
        if (cached) {
          this.apply(cached.reviews, cached.count);
          return;
        }

        try {
          const limit = Number(this.dataset.jmLimit) || 12;
          const reviews = [];
          // 25 per page; walk a few pages until enough pass the rating filter.
          for (let page = 1; page <= 3 && reviews.length < limit; page++) {
            const response = await fetch(this.endpoint('all_reviews_page', `&per_page=25&page=${page}`));
            if (!response.ok) break;
            const data = await response.json();
            const parsed = this.parse(data.all_reviews || '');
            if (!parsed.length) break;
            reviews.push(...parsed);
          }
          if (!reviews.length) return;

          const count = await this.loadCount();
          const trimmed = reviews.slice(0, limit);
          this.writeCache({ reviews: trimmed, count });
          this.apply(trimmed, count);
        } catch {
          // Leave the curated blocks in place.
        }
      }

      async loadCount() {
        try {
          const response = await fetch(this.endpoint('all_reviews_count'));
          if (!response.ok) return null;
          const data = await response.json();
          return data.all_reviews_count || null;
        } catch {
          return null;
        }
      }

      // Judge.me's widget API returns rendered HTML; pull the fields out of the
      // data attributes on their markup, which are stable across their themes.
      parse(html) {
        const minRating = Number(this.dataset.jmMinRating) || 4;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const text = (node, selector) => node.querySelector(selector)?.textContent.trim() || '';

        return Array.from(doc.querySelectorAll('.jdgm-rev'))
          .map((review) => {
            const link = review.querySelector('.jdgm-rev__prod-link');
            return {
              rating: Number(review.querySelector('.jdgm-rev__rating')?.dataset.score || 0),
              author: text(review, '.jdgm-rev__author'),
              title: text(review, '.jdgm-rev__title'),
              body: text(review, '.jdgm-rev__body'),
              date: review.querySelector('.jdgm-rev__timestamp')?.dataset.content || '',
              productTitle: link?.textContent.trim() || '',
              productUrl: link?.getAttribute('href') || '',
            };
          })
          .filter((review) => review.rating >= minRating && review.body.length > 20);
      }

      formatDate(raw) {
        // e.g. "2026-07-20 04:10:36 UTC" — the day alone is enough.
        const date = new Date(`${raw.slice(0, 10)}T00:00:00Z`);
        if (Number.isNaN(date.getTime())) return '';
        return date.toLocaleDateString(document.documentElement.lang || undefined, {
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC',
        });
      }

      // Built with textContent throughout — review text is user-submitted and
      // must never be injected as HTML.
      card(review) {
        const starTemplate = this.querySelector('[data-rc-star]');
        const li = document.createElement('li');
        li.className = this.dataset.rcCardClass || 'rc__card';

        const stars = document.createElement('div');
        stars.className = 'rc__stars';
        stars.setAttribute('aria-label', `${review.rating} out of 5 stars`);
        for (let i = 1; i <= 5; i++) {
          const star = starTemplate.content.firstElementChild.cloneNode(true);
          if (i <= review.rating) star.classList.add('is-filled');
          stars.appendChild(star);
        }
        li.appendChild(stars);

        if (review.title) {
          const title = document.createElement('p');
          title.className = 'rc__title h5';
          title.textContent = review.title;
          li.appendChild(title);
        }

        const body = document.createElement('div');
        body.className = 'rc__body rte';
        const paragraph = document.createElement('p');
        paragraph.textContent = review.body;
        body.appendChild(paragraph);
        li.appendChild(body);

        const meta = document.createElement('div');
        meta.className = 'rc__meta';
        if (review.author) {
          const author = document.createElement('span');
          author.className = 'rc__author';
          author.textContent = review.author;
          meta.appendChild(author);
        }

        const date = this.formatDate(review.date);
        if (review.productTitle || date) {
          const subline = document.createElement('p');
          subline.className = 'rc__subline';
          if (review.productTitle && review.productUrl) {
            subline.appendChild(document.createTextNode('on '));
            const link = document.createElement('a');
            link.href = review.productUrl;
            link.textContent = review.productTitle;
            subline.appendChild(link);
          }
          if (review.productTitle && date) subline.appendChild(document.createTextNode(' · '));
          if (date) subline.appendChild(document.createTextNode(date));
          meta.appendChild(subline);
        }
        li.appendChild(meta);

        return li;
      }

      apply(reviews, count) {
        if (!reviews || reviews.length < 2) return;
        this.track.replaceChildren(...reviews.map((review) => this.card(review)));
        this.build();

        const countEl = this.querySelector('[data-rc-count]');
        if (countEl && count) {
          countEl.textContent = (this.dataset.jmCountText || 'Based on [count] reviews').replace(
            '[count]',
            count.toLocaleString()
          );
          countEl.hidden = false;
        }
      }

      step() {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return this.originals[0].getBoundingClientRect().width + gap;
      }

      // The real set starts one full set-width in (after the leading clones).
      offset() {
        return -(this.count * this.step() + this.index * this.step());
      }

      position(animate) {
        if (animate) {
          // Dragging strips the transition; restore it before moving, or
          // transitionend never fires and normalize() stops wrapping the loop.
          this.track.classList.add('rc__track--animate');
          this.track.getBoundingClientRect(); // commit it before the transform changes
        } else {
          this.track.classList.remove('rc__track--animate');
        }
        this.track.style.transform = `translate3d(${this.offset()}px, 0, 0)`;
        if (!animate) {
          this.track.getBoundingClientRect(); // flush so the jump isn't animated
          requestAnimationFrame(() => this.track.classList.add('rc__track--animate'));
        }
      }

      go(i) {
        this.index = i;
        this.position(true);
      }

      normalize() {
        if (this.index < 0 || this.index >= this.count) {
          this.index = ((this.index % this.count) + this.count) % this.count;
          this.position(false);
        }
      }

      bindDrag() {
        let down = false;
        let startX = 0;
        let base = 0;
        let moved = false;
        let captured = false;

        this.viewport.addEventListener('pointerdown', (event) => {
          if (event.button > 0) return;
          down = true;
          moved = false;
          captured = false;
          startX = event.clientX;
          base = this.offset();
        });

        this.viewport.addEventListener('pointermove', (event) => {
          if (!down) return;
          const dx = event.clientX - startX;
          if (!moved && Math.abs(dx) > 4) {
            // A real drag has started. Only now do we take over the pointer —
            // capturing on pointerdown would steal the click from card links.
            moved = true;
            this.track.classList.remove('rc__track--animate');
            this.viewport.classList.add('is-dragging');
            if (this.viewport.setPointerCapture) {
              this.viewport.setPointerCapture(event.pointerId);
              captured = true;
            }
          }
          if (moved) {
            this.track.style.transform = `translate3d(${base + dx}px, 0, 0)`;
          }
        });

        const release = (event) => {
          if (!down) return;
          down = false;
          this.viewport.classList.remove('is-dragging');
          if (captured && this.viewport.releasePointerCapture) {
            try {
              this.viewport.releasePointerCapture(event.pointerId);
            } catch (e) {}
          }
          captured = false;
          // No drag = a plain click/tap; leave it alone so links navigate.
          if (!moved) return;
          const dx = event.clientX - startX;
          // Cap a single drag at just under one full set, so the landing
          // position is always still inside the cloned cards.
          const max = Math.max(1, this.count - 1);
          const steps = Math.min(max, Math.max(-max, Math.round(-dx / this.step())));
          this.go(this.index + steps);
        };

        this.viewport.addEventListener('pointerup', release);
        this.viewport.addEventListener('pointercancel', release);

        // A real drag shouldn't trigger a card's link.
        this.viewport.addEventListener(
          'click',
          (event) => {
            if (moved) {
              event.preventDefault();
              event.stopPropagation();
              moved = false;
            }
          },
          true
        );
      }
    }

    customElements.define('review-carousel', ReviewCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locations')) {
    class StoreLocations extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('.locations__card'));
        this.mapEl = this.querySelector('[data-locations-map]');
        this.markers = {};

        this.cards.forEach((card) => {
          card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            // Toggle: the active card is the expanded one.
            if (card.classList.contains('is-active')) {
              this.deactivate();
            } else {
              this.activate(card.dataset.location, true);
            }
          });
        });

        // Attribute filters (AND logic): a store must have every selected attribute.
        this.chips = Array.from(this.querySelectorAll('[data-loc-filter]'));
        this.filterClear = this.querySelector('[data-locations-filters] [data-loc-clear]');
        this.emptyEl = this.querySelector('[data-locations-empty]');
        this.selected = new Set();

        this.chips.forEach((chip) => {
          chip.addEventListener('click', () => {
            const val = chip.dataset.locFilter;
            if (this.selected.has(val)) {
              this.selected.delete(val);
              chip.classList.remove('is-active');
            } else {
              this.selected.add(val);
              chip.classList.add('is-active');
            }
            this.applyFilters();
          });
        });

        this.querySelectorAll('[data-loc-clear]').forEach((btn) =>
          btn.addEventListener('click', () => this.clearFilters())
        );

        if (this.mapEl) this.loadLeaflet();
      }

      applyFilters() {
        const selected = Array.from(this.selected);
        let visible = 0;
        this.cards.forEach((card) => {
          const attrs = (card.dataset.attributes || '').split('||').filter(Boolean);
          const match = selected.every((sel) => attrs.includes(sel));
          card.style.display = match ? '' : 'none';
          if (match) visible += 1;

          // Dim (don't remove) the pin so the map keeps its current framing.
          const marker = this.markers[card.dataset.location];
          if (marker && marker.setOpacity) marker.setOpacity(match ? 1 : 0.25);

          // Highlight matching tags on visible cards in that card's pin colour.
          card.style.setProperty('--loc-tag-color', card.dataset.color || 'currentColor');
          card.querySelectorAll('.locations__tag').forEach((tag) => {
            tag.classList.toggle('is-highlight', match && selected.includes(tag.dataset.tag));
          });

          if (!match && card.classList.contains('is-active')) this.deactivate();
        });

        if (this.filterClear) this.filterClear.hidden = selected.length === 0;
        if (this.emptyEl) this.emptyEl.hidden = !(selected.length > 0 && visible === 0);
      }

      clearFilters() {
        this.selected.clear();
        this.chips.forEach((chip) => chip.classList.remove('is-active'));
        this.applyFilters();
      }

      // Load the self-hosted Leaflet script once, then build the map.
      loadLeaflet() {
        if (window.L) {
          this.buildMap();
          return;
        }
        const src = this.dataset.leafletSrc;
        let script = document.querySelector(`script[src="${src}"]`);
        if (!script) {
          script = document.createElement('script');
          script.src = src;
          document.head.appendChild(script);
        }
        script.addEventListener('load', () => this.buildMap());
      }

      buildMap() {
        if (this.map || !window.L) return;
        const located = this.cards.filter((card) => card.dataset.lat && card.dataset.lng);
        if (located.length === 0) return;

        this.map = L.map(this.mapEl, {
          scrollWheelZoom: false, // avoid hijacking page scroll until the map is clicked
          zoomControl: true,
        });

        L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
          maxZoom: 19,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>',
        }).addTo(this.map);

        this.map.on('click', () => this.map.scrollWheelZoom.enable());
        this.mapEl.addEventListener('mouseleave', () => this.map.scrollWheelZoom.disable());

        const pin = parseInt(this.dataset.pinSize, 10) || 32;
        const bounds = [];

        located.forEach((card) => {
          const lat = parseFloat(card.dataset.lat);
          const lng = parseFloat(card.dataset.lng);
          if (Number.isNaN(lat) || Number.isNaN(lng)) return;
          bounds.push([lat, lng]);

          const icon = L.divIcon({
            className: 'locations__marker',
            iconSize: [pin, pin],
            iconAnchor: [pin / 2, pin / 2],
            popupAnchor: [0, -(pin / 2) - 6],
            html: `<span class="locations__pin" style="background-color: ${card.dataset.color};">${card.dataset.index}</span>`,
          });

          const marker = L.marker([lat, lng], { icon, alt: card.dataset.name }).addTo(this.map);
          marker.bindPopup(this.popupHtml(card));
          marker.on('click', () => this.activate(card.dataset.location, false));
          this.markers[card.dataset.location] = marker;
        });

        if (bounds.length > 1) {
          this.map.fitBounds(bounds, { padding: [48, 48] });
          // Start one zoom level further out than the auto-fit for breathing room.
          this.map.setZoom(Math.max(this.map.getZoom() - 1, 3), { animate: false });
        } else {
          this.map.setView(bounds[0], parseInt(this.dataset.zoom, 10) || 13);
        }

        // Only clear the active card on a genuine popup close — not the one
        // Leaflet fires when we're switching from one marker's popup to another.
        this.map.on('popupclose', () => {
          if (!this.switching) this.clearActive();
        });

        new ResizeObserver(() => this.map.invalidateSize()).observe(this.mapEl);
      }

      popupHtml(card) {
        let html = `<p class="locations__popup-name">${card.dataset.name}</p>`;
        if (card.dataset.address) html += `<p class="locations__popup-address">${card.dataset.address}</p>`;
        if (card.dataset.directions) {
          html += `<a class="locations__popup-directions" style="color: ${card.dataset.color};" href="${card.dataset.directions}" target="_blank" rel="noopener">Get directions &rarr;</a>`;
        }
        return html;
      }

      activate(id, panMap) {
        this.cards.forEach((card) => {
          const active = card.dataset.location === id;
          card.classList.toggle('is-active', active);
          const toggle = card.querySelector('.locations__expand');
          if (toggle) toggle.setAttribute('aria-expanded', active ? 'true' : 'false');
        });
        const marker = this.markers[id];
        if (marker && this.map) {
          if (panMap) this.map.panTo(marker.getLatLng());
          // Opening this popup closes any other synchronously; suppress that
          // popupclose so it doesn't clear the card we just activated.
          this.switching = true;
          marker.openPopup();
          this.switching = false;
        }
      }

      deactivate() {
        this.clearActive();
        if (this.map) this.map.closePopup();
      }

      clearActive() {
        this.cards.forEach((card) => {
          card.classList.remove('is-active');
          const toggle = card.querySelector('.locations__expand');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        });
      }
    }

    customElements.define('store-locations', StoreLocations);
  }

  } catch(e) { console.error(e); }
})();
})();
